<div class="play-button round-play-button">
  <button
    (click)="buttonClickedEvent()"
    [title]="hint()"
    class="button-link"
    [ngStyle]="buttonStyles"
  >
    <fa-icon class="play-icon" [icon]="faPlay"></fa-icon>
  </button>
</div>
